import { render, staticRenderFns } from "./ChangedDocumentStatusDialog.vue?vue&type=template&id=53de5c23&scoped=true&"
import script from "./ChangedDocumentStatusDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangedDocumentStatusDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangedDocumentStatusDialog.vue?vue&type=style&index=0&id=53de5c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de5c23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VDivider,VIcon,VStepper,VStepperHeader,VStepperItems,VStepperStep})
